import { defineStyle } from '@chakra-ui/react';

export const AdmonitionBodyStyles = defineStyle({ alignSelf: 'stretch' });
